import { render, staticRenderFns } from "./CampaignInvoice.vue?vue&type=template&id=5d646b5a&scoped=true&"
import script from "./CampaignInvoice.vue?vue&type=script&lang=js&"
export * from "./CampaignInvoice.vue?vue&type=script&lang=js&"
import style0 from "./CampaignInvoice.vue?vue&type=style&index=0&id=5d646b5a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d646b5a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VProgressLinear } from 'vuetify/lib/components/VProgressLinear';
installComponents(component, {VBtn,VCard,VCardText,VContainer,VDataTable,VIcon,VProgressLinear})
